import AcadsPage from 'app/pages/Acads'
import AcadsReviewPage from 'app/pages/Acads/AcadsHq'
import AnalyticsPage from 'app/pages/Analytics'
import ApartmentClustersPage from 'app/pages/Apartment/Admin/Clusters'
import ApartmentComplexesPage from 'app/pages/Apartment/Admin/Complexes'
import ApartmentAttendancePage from 'app/pages/Apartment/Attendance'
import ApartmentBatchesPage from 'app/pages/Apartment/Batches'
import ApartmentClusterDashboardPage from 'app/pages/Apartment/ClusterDashboard'
import ApartmentComingSoonPage from 'app/pages/Apartment/ComingSoon'
import ApartmentDashboardPage from 'app/pages/Apartment/Dashboard'
import ApartmentEnrolmentsPage from 'app/pages/Apartment/Enrolments'
import ApartmentOverviewPage from 'app/pages/Apartment/Overview'
import ApartmentPaymentsPage from 'app/pages/Apartment/Payments'
import ApartmentPayoutPage from 'app/pages/Apartment/Payout'
import ApartmentPerApartmentPage from 'app/pages/Apartment/PerApartment'
import ApartmentPricingPage from 'app/pages/Apartment/Pricing'
import ApartmentProcurementPage from 'app/pages/Apartment/Procurement'
import ApartmentReportsPage from 'app/pages/Apartment/Reports'
import withApartmentBoundary from 'app/pages/Apartment/shared/withApartmentBoundary'
import ApartmentTrialsPage from 'app/pages/Apartment/Trials'
import ApartmentWaitlistPage from 'app/pages/Apartment/Waitlist'
import {
  AtHomeAttendedPage,
  AtHomeDashboardPage,
  AtHomeBookingsPage,
  AtHomeToBookPage,
  AtHomeIssuesPage,
  AtHomeSchedulesPage,
  AtHomeSetupPage
} from 'app/pages/AtHome'
import AtHomeTeacherPage from 'app/pages/AtHome/Teacher'
import AttendancePage from 'app/pages/Attendance'
import PreschoolDailyUpdatesPage from 'app/pages/Audits/PreschoolDailyUpdates'
import TeacherScorecardPage from 'app/pages/Audits/TeacherScorecard'
import AutoBookingPage from 'app/pages/AutoBooking'
import BruceAccessPage from 'app/pages/BruceAccess/BruceAccess'
import CashRegisterPage from 'app/pages/CashRegister'
import CashRegisterHqPage from 'app/pages/CashRegister/Hq'
import ClassBatchesPage from 'app/pages/Class/Batches'
import ClassCoursePage from 'app/pages/Class/Course'
import EnrolmentsPage from 'app/pages/Class/Enrolments'
import ClassInventoryPage from 'app/pages/Class/Inventory'
import ClassMakeUpSessionBookingPage from 'app/pages/Class/MakeUpSession/BookMakeUpSession'
import SessionsPage from 'app/pages/Class/Sessions'
import ClassStandardPage from 'app/pages/Class/Standard'
import ClassSubjectCategoryPage from 'app/pages/Class/SubjectCategory'
import AnnouncementPage from 'app/pages/Communication/Announcement'
import CommunicationBulkMessagingPage from 'app/pages/Communication/BulkMessaging'
import CentreParentChat from 'app/pages/Communication/Chat/CentreParentChat'
import TeacherParentChat from 'app/pages/Communication/Chat/TeacherParentChat'
import InteractionHistoryPage from 'app/pages/Communication/InteractionHistory'
import TicketPage from 'app/pages/Communication/Ticket'
import Moments from 'app/pages/Community/Moments'
import Openbook from 'app/pages/Community/Openbook'
import CsatPage from 'app/pages/Csat/Csat'
import DashboardPage from 'app/pages/Dashboard'
import ParentDashboardPage from 'app/pages/Dashboard/ParentDashboard'
import TeacherDashboardPage from 'app/pages/Dashboard/Teacherdashboard'
import DemoSchedulingPage from 'app/pages/DemoScheduling'
// Not the same thing as IssuesPage above: that is "Issues & Notes"
// (oh_apartments). This is the centre issue tracker (oh_issues).
import InteractionAuditHqRollupPage from 'app/pages/InteractionAudit/HqRollup'
import IssuesPage from 'app/pages/Issues'
import IssueTrackerPage from 'app/pages/IssueTracker'
// Preschool curriculum (Phase 5) — see
// new-code/docs/weekly-skills-migration/phase-5-admin-portal/
import IssueOwnersPage from 'app/pages/IssueTracker/IssueOwners'
import IssuePendingReportPage from 'app/pages/IssueTracker/IssuePendingReport'
import IssuePulsePage from 'app/pages/IssueTracker/IssuePulse'
import PlannerGradeGroupsPage from 'app/pages/LessonPlanner/GradeGroups'
import PlannerInventoryPage from 'app/pages/LessonPlanner/Inventory'
import PlannerLayoutsPage from 'app/pages/LessonPlanner/Layouts'
import ObservationSetupPage from 'app/pages/LessonPlanner/ObservationSetup'
import PlannerPlansPage from 'app/pages/LessonPlanner/Plans'
import PlannerQuotasPage from 'app/pages/LessonPlanner/Quotas'
import PlannerRepositoryPage from 'app/pages/LessonPlanner/Repository'
import PlannerSubjectsPage from 'app/pages/LessonPlanner/Subjects'
import PlannerTimetablesPage from 'app/pages/LessonPlanner/Timetables'
import LoginPage from 'app/pages/LoginPage'
import NewJoinersPage from 'app/pages/NewJoiners'
import NotFoundPage from 'app/pages/NotFoundPage'
import CentreOpsHqPage from 'app/pages/Operations/CentreOpsHq'
import ChecklistsPage from 'app/pages/Operations/Checklists'
import ChecklistSetupPage from 'app/pages/Operations/Checklists/ChecklistHq'
import EventCreativePage from 'app/pages/Operations/EventCreative'
import FieldTripsPage from 'app/pages/Operations/FieldTrips'
import IncidentReportsPage from 'app/pages/Operations/IncidentReports'
import LifeCatchUpsPage from 'app/pages/Operations/LifeCatchUps'
import NewsletterPage from 'app/pages/Operations/Newsletter'
import ParentOnboardingPage from 'app/pages/Operations/ParentOnboarding'
import TeamWallPage from 'app/pages/Operations/TeamWall'
import UnderageConsentPage from 'app/pages/Operations/UnderageConsent'
import OrdersPage from 'app/pages/Orders'
// My Day replaces My Centre (user decision 2026-07-21). The route id, path and
// permission id stay put deliberately — renaming them would need a permission
// migration and would lock everyone out of the page until it ran.
// Everyone on this leaf gets the daily board again (user, 2026-09-10). #839 had
// split it — HQ the board, centre-mapped users MyCentre.js — on the premise that
// the board 403s a centre user. It does not: the page calls daily/ and trends/,
// both open to centre-mapped users since 2026-08-01 and scoped to their own
// centres, so a centre director always saw a working one-centre board.
// InteractionAudit/index.js and MyCentre.js stay on disk, unrouted, so the split
// can be restored by putting this import and the config.js component back.
import PreschoolAnnualLOsPage from 'app/pages/Preschool/AnnualLOs'
import PreschoolMonthlyThemesPage from 'app/pages/Preschool/MonthlyThemes'
import PreschoolSkillsPage from 'app/pages/Preschool/Skills'
import PreschoolSpiralLOsPage from 'app/pages/Preschool/SpiralLOs'
import PreschoolTermReportPage from 'app/pages/Preschool/TermReport'
import PreschoolWeekBuilderPage from 'app/pages/Preschool/WeekBuilder'
import PreschoolWeeklyEvaluationPage from 'app/pages/Preschool/WeeklyEvaluation'
import PreschoolWeeklyEvaluationViewPage from 'app/pages/Preschool/WeeklyEvaluationView'
import ProcurementApprovalsPage from 'app/pages/Procurement/Approvals'
import ProcurementBudgetsPage from 'app/pages/Procurement/Budgets'
import ProcurementCenterTeamPage from 'app/pages/Procurement/CenterTeam'
import ProcurementConsumablesPage from 'app/pages/Procurement/Consumables'
import ProcurementDashboardPage from 'app/pages/Procurement/Dashboard'
import ProcurementHqPage from 'app/pages/Procurement/Hq'
import ProcurementNotificationsPage from 'app/pages/Procurement/Notifications'
import ProcurementPettyCashPage from 'app/pages/Procurement/PettyCash'
import ProcurementProgramMaterialPage from 'app/pages/Procurement/ProgramMaterial'
import ProgramsPage from 'app/pages/Programs'
import ReportIssuePublicPage from 'app/pages/Public/ReportIssuePublic'
import UnderageConsentPublicPage from 'app/pages/Public/UnderageConsentPublic'
import RemindersPage from 'app/pages/Reminders/Reminders'
import RevenueGoalsBoardPage from 'app/pages/RevenueGoals/AllCentresBoard'
import RevenueGoalsHqRollupPage from 'app/pages/RevenueGoals/HqRollup'
import RevenueGoalsMyCentrePage from 'app/pages/RevenueGoals/MyDay'
import RevenueGoalsSetTargetsPage from 'app/pages/RevenueGoals/SetTargets'
import RolesPermissionsPage from 'app/pages/RolesPermissions'
import SchedulerPage from 'app/pages/Scheduler'
import SchoolAttendancePage from 'app/pages/SchoolAttendance'
import SpaceCentrePage from 'app/pages/Space/Centre'
import SubjectsPage from 'app/pages/Subjects'
import TeacherAttendancePage from 'app/pages/Teacher/Attendance'
import LessonPlannerPage from 'app/pages/Teacher/LessonPlanner/LessonPlanner'
import TeacherUpdateCompliancePage from 'app/pages/Teacher/UpdateCompliance'
import UsersPage from 'app/pages/User'
import MergeRequestsPage from 'app/pages/User/MergeRequests'
import VisitorEntryPage from 'app/pages/VisitorEntry'

const RoutePages = {
  AutoBookingPage,
  LoginPage,

  // Users (unified: student/parent/teacher/admin — replaces prior per-role pages; Superprovider retired 2026-05-14)
  UsersPage,
  MergeRequestsPage,

  // Orders (unified: regular/instalment/drop-in-care — replaces 3 prior pages)
  OrdersPage,

  // Operations
  ChecklistsPage,
  ChecklistSetupPage,
  LifeCatchUpsPage,
  ParentOnboardingPage,
  NewsletterPage,
  FieldTripsPage,
  CentreOpsHqPage,
  TeamWallPage,
  EventCreativePage,
  IncidentReportsPage,
  UnderageConsentPage,
  UnderageConsentPublicPage,

  // Issue Tracker — the board, plus the public per-centre issue form.
  IssueTrackerPage,
  ReportIssuePublicPage,

  // Cash Register (own top-level sidebar group: My Centre + HQ)
  CashRegisterPage,
  CashRegisterHqPage,

  // Revenue Goals (own sidebar group)
  RevenueGoalsMyCentrePage,
  RevenueGoalsBoardPage,
  RevenueGoalsSetTargetsPage,
  RevenueGoalsHqRollupPage,

  // Interaction Audit (non-member prospect coverage) — Centre Audit only
  InteractionAuditHqRollupPage,

  // HQ procurement reminder controls + agent audit (super-admin / HQ-admin)
  IssueOwnersPage,
  IssuePendingReportPage,
  IssuePulsePage,
  RemindersPage,
  // HQ -> Bruce access. Owner-only in the sidebar; the endpoints enforce it.
  BruceAccessPage,
  // HQ -> CSAT 2026. Sidebar entry is number-gated in config.js; this route is
  // registered for everyone, and the page carries its own guard.
  CsatPage,
  // HQ -> New Joiners (staff onboarding tracker).
  NewJoinersPage,

  // ACADS (Kolkata tuition) — Kolkata fills, HQ Finance reviews
  AcadsPage,
  AcadsReviewPage,

  // classes pages,
  ClassBatchesPage,
  ClassCoursePage,
  ClassStandardPage,
  ClassSubjectCategoryPage,
  ClassInventoryPage,
  ClassMakeUpSessionBookingPage,

  // Enrolments (unified: event/excel/explore/school-care/toddler-club — replaces 5 prior pages)
  EnrolmentsPage,

  // Subjects (unified: regular/playdate/toddler-club — replaces 3 prior pages)
  SubjectsPage,

  // Programs (unified: categories/subjects/standards/courses — replaces the
  // 4-item Programs submenu with one tabbed page)
  ProgramsPage,

  // Sessions (unified: trial/explore/toddler-club/makeup — replaces 4 prior pages)
  SessionsPage,

  // spaces pages
  SpaceCentrePage,

  // DemoSchedulingPage
  DemoSchedulingPage,

  // communication pages
  CommunicationBulkMessagingPage,
  TicketPage,
  TeacherParentChat,
  CentreParentChat,
  AnnouncementPage,
  InteractionHistoryPage,

  // community pages
  Openbook,
  Moments,

  // attendance
  AttendancePage,

  // Apartments (Openhouse @ Apartment — isolated module)
  ApartmentOverviewPage: withApartmentBoundary(ApartmentOverviewPage),
  ApartmentPerApartmentPage: withApartmentBoundary(ApartmentPerApartmentPage),
  ApartmentDashboardPage: withApartmentBoundary(ApartmentDashboardPage),
  ApartmentEnrolmentsPage: withApartmentBoundary(ApartmentEnrolmentsPage),
  ApartmentPaymentsPage: withApartmentBoundary(ApartmentPaymentsPage),
  ApartmentAttendancePage: withApartmentBoundary(ApartmentAttendancePage),
  ApartmentTrialsPage: withApartmentBoundary(ApartmentTrialsPage),
  IssuesPage,
  ApartmentPayoutPage: withApartmentBoundary(ApartmentPayoutPage),
  ApartmentPricingPage: withApartmentBoundary(ApartmentPricingPage),
  ApartmentClustersPage: withApartmentBoundary(ApartmentClustersPage),
  ApartmentClusterDashboardPage: withApartmentBoundary(
    ApartmentClusterDashboardPage
  ),
  ApartmentComplexesPage: withApartmentBoundary(ApartmentComplexesPage),
  ApartmentProcurementPage: withApartmentBoundary(ApartmentProcurementPage),
  ApartmentBatchesPage: withApartmentBoundary(ApartmentBatchesPage),
  ApartmentWaitlistPage: withApartmentBoundary(ApartmentWaitlistPage),
  ApartmentReportsPage: withApartmentBoundary(ApartmentReportsPage),
  ApartmentComingSoonPage: withApartmentBoundary(ApartmentComingSoonPage),
  AtHomeSchedulesPage,
  AtHomeBookingsPage,
  AtHomeToBookPage,
  AtHomeAttendedPage,
  AtHomeDashboardPage,
  AtHomeIssuesPage,
  AtHomeSetupPage,
  AtHomeTeacherPage,

  // analytics
  AnalyticsPage,
  PreschoolDailyUpdatesPage,

  // Dashboards (unified: parent + teacher lookup behind one "Search" entry)
  DashboardPage,
  ParentDashboardPage,
  TeacherDashboardPage,

  // not found
  NotFoundPage,

  //school
  SchoolAttendancePage,

  // scheduler (standalone iframe to the external Scheduler app)
  SchedulerPage,

  VisitorEntryPage,

  // Preschool curriculum (Phase 5)
  PreschoolWeekBuilderPage,
  PreschoolSkillsPage,
  PreschoolMonthlyThemesPage,
  PreschoolAnnualLOsPage,
  PreschoolSpiralLOsPage,
  PreschoolWeeklyEvaluationPage,
  PreschoolWeeklyEvaluationViewPage,
  PreschoolTermReportPage,

  // Lesson Planner (EarlyLearn)
  PlannerGradeGroupsPage,
  PlannerSubjectsPage,
  PlannerLayoutsPage,
  PlannerQuotasPage,
  PlannerInventoryPage,
  PlannerRepositoryPage,
  PlannerPlansPage,
  ObservationSetupPage,
  PlannerTimetablesPage,
  LessonPlannerPage,
  TeacherAttendancePage,
  TeacherScorecardPage,
  TeacherUpdateCompliancePage,

  // procurement pages
  ProcurementDashboardPage,
  ProcurementBudgetsPage,
  ProcurementPettyCashPage,
  ProcurementConsumablesPage,
  ProcurementProgramMaterialPage,
  ProcurementApprovalsPage,
  ProcurementNotificationsPage,

  // procurement layouts (two views: Center Team + HQ)
  ProcurementCenterTeamPage,
  ProcurementHqPage,

  // roles & permissions (HQ)
  RolesPermissionsPage
}

export default RoutePages
